module.exports = __webpack_public_path__ + "img/TechArchAttack2_ua.af79e0de.webp";